import {WBButton} from '@wandb/weave/common/components/elements/WBButtonNew';
import * as globals from '@wandb/weave/common/css/globals.styles';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled, {css} from 'styled-components';

import editIcon from '../assets/ic-edit.svg';
// eslint-disable-next-line import/no-cycle -- please fix if you can
import {UpdateOverlaySize} from './EditableImage';

export const EditIcon = styled.img.attrs({src: editIcon})`
  margin-right: calc(${globals.spu} * 0.5);
`;

export const UpdateButton = styled(WBButton)<{
  fontSize: UpdateOverlaySize;
}>`
  &&&&& {
    position: absolute;
    right: 5px;
    bottom: 5px;
    margin: 0;
    color: ${globals.white};
    background-color: ${globals.TEAL_500};
    &:hover {
      background-color: ${globals.TEAL_500};
    }

    ${p =>
      p.fontSize === `small` &&
      css`
        font-size: 14px;
        ${EditIcon} {
          width: 18px;
        }
      `}
  }
`;
